exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".table[data-v-1bdb981e]{margin-top:1em;-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important}.avatar[data-v-1bdb981e]{width:50px;height:50px;border:2px solid #ccc;-webkit-box-shadow:2px 2px 10px #888;box-shadow:2px 2px 10px #888}.userRow[data-v-1bdb981e]{font-weight:700;background-color:#efefef}.datePickerContainer[data-v-1bdb981e]{display:-webkit-box;display:-ms-flexbox;display:flex;width:50%}.startDate[data-v-1bdb981e]{margin-right:20px}.link[data-v-1bdb981e]{color:inherit!important;text-decoration:underline!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1bdb981e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/leaderboard/LeaderBoard.vue
// module id = 380
// module chunks = 0